$( document ).ready(function() {
  
  if($(".template-product").length > 0){
    
    $(".box--Custom-properties").on("change", "select", function(e){
      var value = $(this).val();
      $(this).parents(".box--Custom-properties").find(".variant-label-option-value").text(value)
    });
    
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= $(".product-single__add-to-cart .btn--add-to-cart").offset().top) {
            $(".btn--add-to-cart-custom").addClass("is-active");
        } else{
            $(".btn--add-to-cart-custom").removeClass("is-active"); 
        }
    });
  
    $(".product-section").on("click", ".btn--add-to-cart-custom", function(e){
      e.preventDefault();
      $( ".Custom__properties-select .select__select" ).each(function() {    
        $( ".btn--add-to-cart" ).trigger( "click" );
        if( $( this ).val() == null){
          $('html,body').animate({
              scrollTop: $(".product-single__meta").offset().top
          },'slow');
        }
        
      });
    });
  
    $(".dbtfy-upsell_bundles ").on("change", ".Custom__properties_upsell .Custom__properties-select .select__select", function(e){
      var $this = $(this);
      $this.removeClass("invalid");
      $this.parents(".Custom__properties-select").find(".error").removeClass("is-error");
      var value = $this.val();
      
      var html = `<option value="" selected="" disabled="">${Translations.choose_one}</option>`;
      if($(this).data("id") == "brand"){
        $this.parents(".Custom__properties_upsell").find(".Custom__properties-label_value").text(value);
        $this.parents(".Custom__properties_upsell").find(".select__select[data-id='model']").attr('name', `properties[${value} Model]`);
        $this.parents(".Custom__properties_upsell").find(".select__select[data-id='model']").attr('name-properties', `${value} Model`);
        Models.forEach(function(model){
          if(value == model.Brand){
            model.Models.split(/[,]+/).map(function(item){
              return html += `
                <option value="${item}">${item}</option>
              `
            })   
            $this.parents(".Custom__properties_upsell").find(".select__select[data-id='model']").html(html)
          }
        })
        
      }
    });

    $(".template-product ").on("change", " .Custom__properties-select .select__select", function(e){
      var $this = $(this);
      var ID = $this.parents(".Custom__properties-select").data("id");
      if(ID == "car-make"){
        $this.parents(".Custom__properties-select").siblings().fadeIn();
      }
    });


    $(".template-product ").on("click", " .product-single__add-to-cart .btn--add-to-cart", function(e){
      var $this = $(this);
      var tempOject = {};
      var checkValue = false
      var title = $this.parents(".product-single__meta").find(".product-single__title").text().trim();
      var number_of_seats = $this.parents(".product-single__meta").find("#SingleOptionSelector-1").val();
      var color = $this.parents(".product-single__meta").find(".swatch .input-color_swatches:checked").val();
      $this.parents(".product-single__form").find(".box--Custom__properties .select__select").each(function( index ) {
        var name = $(this).attr("name-properties");
        var value = $(this).val();
        if(value != null){
          checkValue = true
        }
        tempOject[name] = value
      });
      if(checkValue){
        var tempnoteOrder = localStorage.getItem("noteOrder");
        if(tempnoteOrder == null){
          localStorage.setItem("noteOrder", "");
        }
        var noteOrder = localStorage.getItem("noteOrder");
        var convertempOject = JSON.stringify(tempOject);
        if(typeof number_of_seats == "undefined"){
          var noteProduct = `${title} -- ${color}:${convertempOject}`;
        } else {
          var noteProduct = `${title} -- ${color} / ${number_of_seats}:${convertempOject}`;
        }
        
        if(noteOrder == ""){
          newNoteOrder = `${noteProduct}`;
        } else {
          newNoteOrder = `${noteOrder};${noteProduct}`;
        }       
        localStorage.setItem("noteOrder", newNoteOrder);   
        setTimeout(() => {
         $("#CartSpecialInstructions").val(newNoteOrder)
        }, 3500);
      }
    });
  }

  $("body").on("click", " .cart__product-remove", function(e){  
    e.preventDefault();
    var array = localStorage.getItem("noteOrder");
    var newArr = array.split(';');
    var valuesToRemove = $(this).parents(".cart__product-name").find(".title").data("title");
    newArr.forEach((item)=>{
      const checkValue = item.includes(valuesToRemove);
      if (checkValue) { // only splice array when item is found
        const index = newArr.indexOf(item);
        newArr.splice(index, 1); // 2nd parameter means remove one item only
      }
    })
    if(newArr.length == 0){
      var convertempArr = "";
    } else {
      var convertempArr = newArr.join(";");
    }    
    localStorage.setItem("noteOrder", convertempArr);
    setTimeout(() => {
      $(".cart__note textarea").val(convertempArr)
    }, 1500);
    
  });
  if($(".template-cart").length > 0){
    var noteCart = localStorage.getItem("noteOrder");
    $(".cart__note textarea").val(noteCart)
    $(".cart-form").on("click", " .cart__checkout", function(e){
      localStorage.removeItem("noteOrder");      
    });
     $(".template-cart").on("change", ".card-footer--checkbox #card-footer--input", function(e){
      var ID = $(this).data("id");
      if($(this).is(":checked")){
        $.ajax({
           type: 'POST',
           url: '/cart/add.js',
           data: {
              quantity: 1,
              id: ID
           },
           dataType: 'json',
           success: function (data) {
              let cart = jQuery.getJSON('/cart.js');            
              cart.done(function(){
                cart = cart.responseJSON;
                let items = cart.items;
                addCompareAtPrice(cart);               
              })
              function addCompareAtPrice(cart) {
                  cart.items.forEach(function(item) {
                      $.ajax({
                          url: '/products/' + item.handle + '.js',
                          dataType: 'json',
                          async: false,
                          success: function(product) {
                              item["compare_at_price"] = 0;
                              product.variants.forEach(function(variant) {
                                  if (variant.compare_at_price != null && variant.id == item.variant_id) {
                                      item["compare_at_price"] = variant.compare_at_price;
                                  }
                              });
                          }
                      });
                      console.log(item["compare_at_price"])
                  });
                  
                  return cart;
              }
           }
        });        
      } else {
        $.ajax({
           type: 'POST',
           url: '/cart/change.js',
           data: {
              quantity: 0,
              id: ID
           },
           dataType: 'json',
           success: function (data) {

           }
        });
      }
    });
  }

});
